import React from "react";
import { Carousel } from "../Carousel/Carousel";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

interface ImageDetails {
  imageUrl: string;
  title: string;
  imageName?: string;
}

interface TTImageCarouselProps {
  items: ImageDetails[];
  index: number;
}

export const TTImageCarousel = (props: TTImageCarouselProps) => {
  const { items, index } = props;
  return (
    <Carousel
      initialPageIndex={index}
      hasPager={false}
      totalItems={items.length}
      paginateSingleItem
      itemsToDisplay={{ DESKTOPXL: 1, DESKTOP: 1, TABLET: 1, MOBILE: 1 }}
    >
      <EgCarousel page={index} itemsPerPage={1} items={items} />
    </Carousel>
  );
};

export const EgCarousel = (props: any) => {
  const { page, itemsPerPage, items } = props;
  const slicedItems = items.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );

  return (
    <ReactCSSTransitionGroup
      transitionName="carousel__animation"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
      className="carousel__animation-container ab-carousel"
    >
      {slicedItems.map((item: ImageDetails) => {
        return (
          <div className="ab-carousel__item" key={item.title}>
            <div>
              <div className="ab-carousel__img-container">
                <img alt={item.imageName} src={item.imageUrl} />
              </div>
              <p>{item.title}</p>
            </div>
          </div>
        );
      })}
    </ReactCSSTransitionGroup>
  );
};
